import { validateFile } from '@om/validation';
import { AMC_UPLOAD_DOCUMENTS_CONFIG, setAmcDocumentValid } from '../../../actions/allSureMotorClaim/uploadDocuments';

let prevValidationAction = null;
export const uploadDocumentsValidation = (store, next, action) => {
    const validationAction = (() => {
        let error;
        error =  validateFile(action.value.fileContaint, {
                  minInputSize: AMC_UPLOAD_DOCUMENTS_CONFIG.MIN_INPUT_SIZE,
                  minInputSizeName: AMC_UPLOAD_DOCUMENTS_CONFIG.MIN_INPUT_SIZE_NAME,
                  maxInputSize: AMC_UPLOAD_DOCUMENTS_CONFIG.MAX_INPUT_SIZE,
                  maxInputSizeName: AMC_UPLOAD_DOCUMENTS_CONFIG.MAX_INPUT_SIZE_NAME,
                  validFileTypes: AMC_UPLOAD_DOCUMENTS_CONFIG.VALID_UPLOAD_TYPES,
                  required:false
              })
            ;
        if (action.value.inputType) {
            return setAmcDocumentValid(error, action.value.inputType);
        } else {
            return null;
        }
    })();
    if (!validationAction) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
